import { render } from "./WorldClassTech.vue?vue&type=template&id=36ca686f&scoped=true"
const script = {}

import "./WorldClassTech.vue?vue&type=style&index=0&id=36ca686f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ca686f"]])

export default __exports__